import { Component, OnInit } from '@angular/core';

async function deconnecter_fn() {
  var audio = new Audio('../assets/aud/exit.ogg');
  audio.play();
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;

} ;

function aproposdefn() {
  alert("Bonjour !! \n\n Ceci est un mini-projet ISTIC pour le niveau LGLSI-2 en 2021 \n Réalisé par: Mohamed Dhia Jebali - Mariem Benjaballah - Aymen Tayari \n\n C'est une application web faite par angular pour la gestion des employés \n Vous pouvez ajouter, modifier, supprimer, chercher et consulter chaque employé dans la base de données de l'application");
}

function hoversoundfn() {
  var audio = new Audio('../assets/aud/cursor.ogg');
audio.play();
}

function clicksoundfn() {
  var audio = new Audio('../assets/aud/select.ogg');
audio.play();
}

async function backend_tester_fn() {
  var eid = localStorage.getItem("connecteid");
  var motdepasse = localStorage.getItem("connectmdp");
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_connecter_bd?eid=${eid}&motdepasse=${motdepasse}`) ;   
  if (rep.ok){
    rep.json().then((data)=>{ 
      if (data.length != 0) {
        if (data[0].admin == 1) {
          (document.getElementById("connectnomm") as HTMLFormElement).insertAdjacentHTML("afterbegin",data[0].nom+" ") ;
        }
        if (data[0].admin == 0) {
          window.location.href = '/accueilemploye' ;
        }
      }
      else {
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;
      }
    }) 
  } else {
    localStorage.removeItem("connecteid");
    localStorage.removeItem("connectmdp");
    localStorage.removeItem("connectnom");
    window.location.href = '/connecter' ;
  }
} ;

async function backend_supprimer_chercher_fn() {

  var eid = (document.getElementById("eid") as HTMLFormElement).value ;
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_modifier_chercher_bd?eid=${eid}`) ;   
  

  if (rep.ok){

    rep.json().then((data)=>{ 


      (document.getElementById('cin') as HTMLFormElement).value =  data[0].cin ;


      (document.getElementById('prenom') as HTMLFormElement).value =  data[0].prenom ;
     

      (document.getElementById('nom') as HTMLFormElement).value =  data[0].nom ;

      var imgg = data[0].photo ;
      (document.getElementById('imgg') as HTMLFormElement).innerHTML =  `         <div class=" text-center col-sm-12 col-md-12 col-lg-12 col-xl-12" id="imgg">
      <img src="`+imgg+`"  width="120" height="120" /> <br><br>
      <h2>Photo</h2>
  </div>` ;
      

    })


    const rep2 = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_chercher_tache_bd?eid=${eid}`) ;   
  
    if (rep2.ok){
      rep2.json().then((data)=>{ 

        if (data.length == 0) {

          var audio = new Audio('../assets/aud/miss.ogg');
          audio.play();

          alert("Aucun cin n'a été trouvé dans la base de données ") ;

          (document.getElementById('supprimersub') as HTMLFormElement).disabled = true ;
          (document.getElementById('tlist') as HTMLFormElement).disabled = true ;



        } else {
          
          (document.getElementById('supprimersub') as HTMLFormElement).disabled = false ;
          var audio = new Audio('../assets/aud/loaded.ogg');
          audio.play();
      }
  
        

        (document.getElementById('tlist') as HTMLFormElement).innerHTML = `<select style="width: 250px; font-size:18px;" name="tlist" id="tlist"> <option value="tilist">appuyez pour l'affichier</option> </select>` ;
        (document.getElementById('tlist') as HTMLFormElement).disabled = false ; 
        for(var i=0 ; i<data.length;i++) {
          (document.getElementById('tlist') as HTMLFormElement).insertAdjacentHTML("beforeend",`<option value="tilist"> ${data[i].tachenom} / ${data[i].directeureid}</option> ` ) ;
        }
  
  
      }) 
    }

    

  }
} ;

async function backend_supprimer_fn() {

  let url = "http://127.0.0.1:8000/gestionemployes/backend_supprimer_tache_bd" ;
  var eid = (document.getElementById("eid") as HTMLFormElement).value ;
  let post = `{"eid":"${eid}"}` 
  const rep = await fetch(url, {
    method:"POST" , 
    body : post
  })

  if (rep.ok){

    let url = "http://127.0.0.1:8000/gestionemployes/backend_supprimer_compte_bd" ;
    var eid = (document.getElementById("eid") as HTMLFormElement).value ;
    let post = `{"eid":"${eid}"}` 
    const rep = await fetch(url, {
      method:"POST" , 
      body : post
    })
  
    if (rep.ok){

      let url = "http://127.0.0.1:8000/gestionemployes/backend_supprimer_personne_bd" ;
      var cin = (document.getElementById("cin") as HTMLFormElement).value ;
      let post = `{"cin":"${cin}"}` 
      const rep = await fetch(url, {
        method:"POST" , 
        body : post
      })
    
      if (rep.ok){
        var audio = new Audio('../assets/aud/success.ogg');
        audio.play(); alert("La suppression a réussi !") ;
    
    }
  
  } else {

    var audio = new Audio('../assets/aud/success.ogg');
    audio.play(); alert("La suppression a échoué. \n il y a certaines tâches où cet employeur est son directeur, assurez-vous de changer le directeur de ces tâches") ;


  }

}

};

@Component({
  selector: 'app-supprimer',
  templateUrl: './supprimer.component.html',
  styleUrls: ['./supprimer.component.css']
})
export class SupprimerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    backend_tester_fn() ;
  }
  
  aproposderun() {
    aproposdefn();
  }

  hoversound() {
    hoversoundfn();
  }

  clicksound() {
    clicksoundfn();
  }

  backend_supprimer_chercher() {
    backend_supprimer_chercher_fn();
  }

  backend_supprimer() {
    backend_supprimer_fn();
  }

  deconnecter() {
    deconnecter_fn() 
  }
  

}
